import React from 'react';
import PropTypes from 'prop-types';
import styled, { css, keyframes } from 'styled-components';
import { Typography } from '@quikr/ui';

const SubWrap = styled.ul`
  height: 50px;
  width: 50%;
`;

const NewTag = styled(Typography)`
  height: 15px;
  background: ${({ theme }) => theme.colors.NewTagGradient};
  color: #ffffff;
  border-radius: 2px;
  padding: 0 4px;
  transform: scale(0.85);
`;

const loading = keyframes`
  0% {
    opacity: 0;
    transform: translateY(-20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

const DropDownList = styled.div`
  display: none;
  animation-name: ${loading};
  animation-duration: 0.3s;
  top: 50px;
  width: 180px;
  z-index: 3;
  background: #ffffff;
  border-radius: 4px;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1), 0 8px 8px 0 rgba(0, 0, 0, 0.05);
`;

const Wrap = styled.li`
  cursor: pointer;
  height: 50px;
  padding-right: 35px;
  color: ${({ theme }) => theme.colors.TextBeta};
  &:first-child {
    ${({ direction }) =>
      direction &&
      css`
        padding-${direction.toLowerCase()}: 15px;
      `}
  }
  &:hover > a {
    color: ${({ theme }) => theme.colors.Primary};
  }
  ${({ dropdown }) =>
    dropdown &&
    css`
      &:after {
        content: '';
        width: 0;
        height: 0;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-bottom: 5px solid ${({ theme }) => theme.colors.TextBeta};
        text-align: center;
        transform: rotate(180deg);
        transition: transform 0.3s;
      }
      &:hover:after {
        border-bottom: 5px solid ${({ theme }) => theme.colors.Primary};
        transition: transform 0.3s;
        transform: rotate(360deg);
      }
      &:hover ${DropDownList} {
        display: block;
      }
    `}
`;

const Typo = styled(Typography)`
  padding-right: 7px;
  color: ${({ theme }) => theme.colors.TextBeta};
`;

const ListKey = styled.a`
  color: ${({ theme }) => theme.colors.TextAlpha};
  padding: 12px 24px;
  transition: all 0.3s ease-out;
  &:hover {
    background-color: ${({ theme }) => theme.colors.Neutral[500]};
  }
`;

const Wrapper = styled.div`
  position: sticky;
  top: 91px;
  z-index: 2;
  margin: -21px 0 15px;
  background: ${({ theme }) => theme.colors.Neutral[500]};
`;

const DropDown = ({data, key}) => (
  <DropDownList className="pA wsN dropDownList" key={key}>
    {data.links.map(({ href, label }, index) => (
      <ListKey className="dB bt2 fwM" href={href} key={index}>
        {label}
      </ListKey>
    ))}
  </DropDownList>
);

const SubHeader = ({ subHeaderLinks }) => {
  const { right = [], left = [] } = subHeaderLinks;
  return (
    <Wrapper className="dF">
      <SubWrap className="dF">
        {left.map((each, index) => (
          <Wrap className="dFA" key={index} direction="left" dropdown={each.dropdown}>
            <Typo tagName="a" modifiers={['bold', 'bt2']} href={each.href} className="wsN">
              {each.label}
            </Typo>
            {each.dropdown && <DropDown key={index} data={each} />}
          </Wrap>
        ))}
      </SubWrap>
      {process.env.BUILD_TARGET === 'client' && (
        <SubWrap className="dF fdrR">
          {right.map((each, index) => (
            <Wrap
              className="dFA"
              key={left.length + index}
              direction="right"
              dropdown={each.dropdown}
            >
              <Typo tagName="a" modifiers={['bold', 'bt2']} href={each.href} className="wsN">
                {each.label}
              </Typo>
              {each.isnew && (
                <NewTag tagName="span" modifiers={['medium', 'bt3']}>
                  NEW
                </NewTag>
              )}
              {each.dropdown && <DropDown key={index} data={each} />}
            </Wrap>
          ))}
        </SubWrap>
      )}
    </Wrapper>
  );
};

SubHeader.propTypes = {
  subHeaderLinks: PropTypes.object,
  right: PropTypes.object,
  left: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      dropdown: PropTypes.bool,
      href: PropTypes.string,
      links: PropTypes.array,
      isnew: PropTypes.bool
    })
  ),
  data: PropTypes.object
};

SubHeader.defaultProps = {
  subHeaderLinks: {}
};

export default SubHeader;
